<div class="outer-wrapper">
	<app-header *ngIf="showHeader"></app-header>

	<app-dialog-success></app-dialog-success>
	<app-dialog-error></app-dialog-error>
	<app-dialog-confirm></app-dialog-confirm>

	<div class="loader-api" *ngIf="showLoader">
		<div class="loading-api">
			<div class="circle-loader">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</div>

	<div class="inner-wrapper">
		<router-outlet (activate)="onActivate($event)"></router-outlet>
	</div>

	<app-footer *ngIf="showHeader"></app-footer>


</div>
